exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.Log[data-v-6812a9a8]{max-height:167px;overflow:auto;border:1px solid var(--shadowColor);font-size:11px;color:var(--logColor)\n}\n.Log-text[data-v-6812a9a8]{padding:15px;overflow-wrap:break-word;word-wrap:break-word\n}", "", {"version":3,"sources":["/opt/front/src/components/modeling/Log.vue"],"names":[],"mappings":";AACA,sBAAsB,iBAAiB,cAAc,oCAAoC,eAAe,qBAAqB;CAC5H;AACD,2BAA2B,aAAa,yBAAyB,oBAAoB;CACpF","file":"Log.vue","sourcesContent":["\n.Log[data-v-6812a9a8]{max-height:167px;overflow:auto;border:1px solid var(--shadowColor);font-size:11px;color:var(--logColor)\n}\n.Log-text[data-v-6812a9a8]{padding:15px;overflow-wrap:break-word;word-wrap:break-word\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6812a9a8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/modeling/Log.vue
// module id = yBdz
// module chunks = 40